import { parseISO, format } from 'date-fns';

const getYear = (dateISOString: string) => {
  const parsedDate = parseISO(dateISOString);

  return format(parsedDate, 'yyyy');
};

export default getYear;
